import { ResponsivePie } from "@nivo/pie";
import { Box } from "@mui/material";
import { WaydFrequencyChartProps } from "./types";
import { getWaydFrequencyChartData } from "./utils";
import { Typography } from "@mui/material";

export default function WaydFrequencyChart({ data }: WaydFrequencyChartProps) {
  if(typeof data === 'string' || !data) {
    return <Typography variant="body1" textAlign="center">No role data available</Typography>;
  }
  return (
    <Box sx={{ height: 200, width: 300 }}>
      <ResponsivePie
        data={getWaydFrequencyChartData(data)}
        margin={{ top: 25, right: 0, bottom: 25, left: 0 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        colors={{ datum: "data.color" }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#000000"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLinkLabelsStraightLength={8}
        arcLinkLabelsDiagonalLength={8}
        enableArcLabels={false}
        borderWidth={0.5}
        borderColor="#000000"
      />
    </Box>
  );
}
